import React from "react";
import MultipleSelect from "../../../components/common/MultipleSelect/MultipleSelect";
import RadioInput from "../../../components/common/RadioInput/RadioInput";
import TextInput from "../../../components/common/TextInput/TextInput";
import UploadFile from "./UploadFile";


const valueContainer = {
    display: "flex",
    gap: "5px",
};

const TextInfo = ({
    title,
    value,
    type = "text",
    isTextArea = false,
    isInputNumber = false,
    radioData,
    id,
    handleChange,
    error = "",
    placeholder,
    isSearchable = false,
    selectOptions = [],
    isForm = false,
    helperText = "",
    handleImageChange,
    customRequest,
    fileList,
    isStyleBlock = false,
}) => {
    return (
        <>
            {isTextArea && isStyleBlock ? (
                <div className="row">
                    <div className="col-4">
                        <div className="modal-title" style={{ marginBottom: "10px" }}>
                            {title} :
                        </div>
                    </div>
                    <div className="col-8">
                        <TextInput
                            id={id}
                            isInputNumber={isInputNumber}
                            isTextArea={isTextArea}
                            handleChange={handleChange}
                            value={value}
                            width="100%"
                            errorText={error}
                            placeholder={placeholder}
                            isForm={isForm}
                        />
                    </div>
                </div>
            ) : (
                <>
                    <div className="modal-title">{title}</div>
                    {type === "text" ? (
                        <div style={valueContainer}>
                            : <div>{value}</div>
                        </div>
                    ) : type === "select" ? (
                        <div className="d-flex modal-input align-items-flex-start">
                            <span>: </span>
                            <MultipleSelect
                                id={id}
                                label={title}
                                value={value}
                                isSearchable={isSearchable}
                                onSelectChange={handleChange}
                                placeholder={placeholder}
                                options={selectOptions}
                                isForm={isForm}
                                width="100%"
                                errorText={error}
                            />
                        </div>
                    ) : type === "upload" ? (
                        <div className="d-flex modal-input align-items-flex-start ">
                            {/* <span>: </span> */}
                            <UploadFile
                                id={id}
                                buttonText={"Tambah File"}
                                isForm={isForm}
                                width="100%"
                                helperText={helperText}
                                handleImageChange={handleImageChange}
                                customRequest={customRequest}
                                fileList={fileList}
                                errorText={error}
                            />
                        </div>
                    ) : type === "radio" ? (
                        <div className="d-flex modal-input align-items-flex-start">
                            <span>: </span>
                            <div className="d-flex flex-column">
                                <RadioInput
                                    id={id}
                                    radioData={radioData}
                                    handleChange={handleChange}
                                    errorText={error}
                                    width="100%"
                                    isForm
                                />
                            </div>
                        </div>
                    ) : (
                        <div className="d-flex modal-input align-items-flex-start">
                            <span>: </span>
                            <TextInput
                                id={id}
                                isInputNumber={isInputNumber}
                                isTextArea={isTextArea}
                                handleChange={handleChange}
                                value={value}
                                width="100%"
                                errorText={error}
                                placeholder={placeholder}
                                isForm={isForm}
                            />
                        </div>
                    )}
                </>
            )}
        </>
    );
};

export default TextInfo;
